module.exports = __webpack_public_path__ + "img/Judy_Kay.01902064.png";